import {useEffect, useState} from "react";
import * as React from "react";
import {Box, Container, Divider, InputLabel, Alert} from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import {PATCH, GET} from "APIclient";
import Snackbar from "@mui/material/Snackbar";
import {useLocation} from "react-router-dom";
import properties from "constants/ApplicationConstants";

function BankDetails() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const empId = location.state || window.sessionStorage.getItem("empId");
  const [snakColor, setSnakColor] = React.useState("");
  const [snakMessage, setSnakMessage] = React.useState("");
  const [inputs, setInputs] = useState({
    bankName: "",
    bankAcnumber: "",
    nameInBank: "",
    ifsc: "",
    micr: ""
  });
  const [isEdited, setIsEdited] = useState(false);
  const [hasBankDetailsPermission, setHasBankDetailsPermission] = useState(false);

  const url1 = `employee/employee-details/${empId}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GET(url1);
        const data = response?.data?.data;

        if (data && response.data.statusCode === 200) {
          setInputs(prevInputs => ({
            ...prevInputs,
            ...data.employee
          }));
          setHasBankDetailsPermission(data?.employee.permissions.includes("bank_details"));
        } else {
          console.log("Error:", response.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const [errors, setErrors] = useState({
    bankName: "",
    bankAcnumber: "",
    nameInBank: "",
    ifsc: "",
    micr: ""
  });

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = e => {
    if (!hasBankDetailsPermission) return;

    const {name, value} = e.target;
    setInputs(prevInputs => ({
      ...prevInputs,
      [name]: value
    }));
    validateField(name, value);

    if (value !== inputs[name]) {
      setIsEdited(true);
    } else {
      setIsEdited(false);
    }
  };

  const validateField = (name, value) => {
    let errorMessage = "";

    if (name === "bankName") {
      if (value.trim() === "") {
        errorMessage = "Bank Name is required.";
      } else if (/\d/.test(value)) {
        errorMessage = "Bank Name should not contain numbers.";
      }
    } else if (name === "bankAcnumber") {
      if (value.trim() === "") {
        errorMessage = "Account Number is required.";
      } else if (!/^\d{9,18}$/.test(value)) {
        errorMessage = "Account Number must be between 9 to 18 digits.";
      } else if (isNaN(value)) {
        errorMessage = "Account Number should be numeric.";
      }
    } else if (name === "nameInBank") {
      if (value.trim() === "") {
        errorMessage = "Name in Bank is required.";
      } else if (!/^[A-Za-z\s,.-]+$/.test(value)) {
        errorMessage = "Name in Bank should not contain numbers.";
      }
    } else if (name === "ifsc" && value.trim() === "") {
      errorMessage = "IFSC Code is required.";
    } else if (name === "ifsc" && !/^[A-Za-z]{4}\d{7}$/.test(value)) {
      errorMessage = "Please enter a valid IFSC code.";
    }

    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: errorMessage
    }));
  };

  const url = `employee/bank-details`;
  const handleSubmit = async () => {
    if (!hasBankDetailsPermission) return;

    const inputData = {empId: empId, ...inputs};
    console.log("formDataObj", inputData);

    try {
      let response = await PATCH(url, inputData);
      response = response.data;
      if (response?.statusCode === 200) {
        setSnakColor("success");
        setSnakMessage(response?.message);
        setOpen(true);
        setIsEdited(false);
      }
    } catch (error) {
      setSnakMessage(error.response?.data?.message || "Failed to save bank details.");
      setSnakColor("error");
      setOpen(true);
    }
  };

  return (
    <Container>
      <MDBox pt={4} pb={3} px={3} component="form" onSubmit={e => e.preventDefault()}>
        <MDBox mb={4} mr={3}>
          <InputLabel sx={{fontWeight: "bold", fontFamily: properties.fontFamily}} mb={2}>
            Bank Details<span style={{color: properties.colors.Red}}>*</span>
          </InputLabel>
          <MDInput
            sx={{m: 1, width: "30ch"}}
            type="text"
            label={
              <span>
                Bank Name<span style={{color: properties.colors.Red}}>*</span>
              </span>
            }
            name="bankName"
            value={inputs.bankName || ""}
            onChange={handleChange}
            variant="standard"
            error={!!errors.bankName}
            helperText={errors.bankName}
            disabled={!hasBankDetailsPermission}
          />
          <MDInput
            sx={{m: 1, width: "30ch"}}
            type="text"
            label={
              <span>
                Account Number<span style={{color: properties.colors.Red}}>*</span>
              </span>
            }
            name="bankAcnumber"
            value={inputs.bankAcnumber || ""}
            onChange={handleChange}
            variant="standard"
            error={!!errors.bankAcnumber}
            helperText={errors.bankAcnumber}
            disabled={!hasBankDetailsPermission}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            sx={{m: 1, width: "30ch"}}
            type="text"
            label={
              <span>
                Name in Bank<span style={{color: properties.colors.Red}}>*</span>
              </span>
            }
            name="nameInBank"
            value={inputs.nameInBank || ""}
            onChange={handleChange}
            variant="standard"
            error={!!errors.nameInBank}
            helperText={errors.nameInBank}
            disabled={!hasBankDetailsPermission}
          />
          <MDInput
            sx={{m: 1, width: "30ch"}}
            type="text"
            label={
              <span>
                IFSC<span style={{color: properties.colors.Red}}>*</span>
              </span>
            }
            name="ifsc"
            value={inputs.ifsc || ""}
            onChange={handleChange}
            variant="standard"
            error={!!errors.ifsc}
            helperText={errors.ifsc}
            disabled={!hasBankDetailsPermission}
          />
        </MDBox>
        <MDBox mb={4} mr={3}>
          <MDInput
            sx={{m: 1, width: "30ch"}}
            type="text"
            label="MICR"
            name="micr"
            value={inputs.micr || ""}
            onChange={handleChange}
            variant="standard"
            error={!!errors.micr}
            helperText={errors.micr}
            disabled={!hasBankDetailsPermission}
          />
        </MDBox>
        <Divider />
        <MDBox mt={2} mb={1} sx={{display: "flex", justifyContent: "flex-end"}}>
          <MDButton
            variant="gradient"
            color="info"
            sx={{width: "30ch", background: properties.colors.bgcolorbluethem}}
            onClick={handleSubmit}
            disabled={!hasBankDetailsPermission || !isEdited}
          >
            Save
          </MDButton>
        </MDBox>

        <Snackbar
          open={open}
          anchorOrigin={{vertical: "top", horizontal: "right"}}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={snakColor === "success" ? "success" : "error"}
            variant="filled"
            sx={{width: "100%", color: "#fff"}}
          >
            {snakMessage}
          </Alert>
        </Snackbar>
      </MDBox>
    </Container>
  );
}

export default BankDetails;
